
 

<template>
<!--

  - Si tiene fecha de entrata y no  tiene gia o idpaquete (indica que esta en el almacen pero no  ha sido proocesado) el paquete se encuantra en nuestras instalaciones, cree una prealerta para agilizar el proceso.
  - Si no tiene fecha  de entrada ni  id paquete, El paquete no esta  en nuestro alamacen para agilizar el proceso de registro al legar prealerte el mismo.
  - si no  tiene fecha de entrada, pero si tiene guia, (Indica que no  se le dio entrada en miami) 
  
-->
  <v-layout row>
    <v-flex xs12>
    <v-toolbar app>
    <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
    <v-toolbar-title>Solicitar  Información</v-toolbar-title>
    <v-spacer></v-spacer>
     <v-btn icon to="/prealert"> 
              <v-icon>cancel</v-icon> 
            </v-btn>
  </v-toolbar>
        
        
          <div class="pt-4 pl-4 pr-4">
            <v-card class="login-form">
              <v-card-text class="">
                <v-form v-model="valid">
                  <h2 class="headline">Ingresar el numero de tracking</h2>
                  
                  <v-text-field required :rules="required" v-model="text4" label="Numero de Tracking" type="text"></v-text-field>            
                                  
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn :disabled="!valid" block color="primary" @click="validateLogin">Consultar</v-btn>
              </v-card-actions>
              
            </v-card>
          </div>
          <div  class="pl-2 pr-2" v-if="Searh.length  > 0  ">  
          <v-list two-line class="list-view" v-if="Searh[0].fecha_entrada !== '' || Searh[0].fecha_registro !== ''">
          <template  >
            <v-list-tile class="list-view-item"
              avatar
              ripple
             
            >
              <v-list-tile-content>
                <v-list-tile-title :class="'bg-blue pack-title'">Detalle de la  consulta</v-list-tile-title> 
                <table class="pack-list-table">
                  <tr v-if="Searh[0].carrier!=''">
                    <th>Carrier </th>
                    <td>{{Searh[0].carrier}}</td>
                  </tr>
                  
                  <tr v-if="Searh[0].fecha_entrada!=''">
                    <th>Fecha Entrada </th>
                    <td>{{Searh[0].fecha_entrada}}</td>
                  </tr>

                  <tr v-if="Searh[0].trackingnumber!=''">
                    <th>Tracking Number </th>
                    <td>{{Searh[0].trackingnumber}}</td>
                  </tr>


                  <tr v-if="Searh[0].desc_estatus_proceso!=''">
                    <th>Estatus</th>
                    <td>{{Searh[0].desc_estatus_proceso}}</td>
                  </tr>

                  <tr v-if="Searh[0].fecha_registro!=''">
                    <th>Fecha Registro</th>
                    <td>{{Searh[0].fecha_registro}}</td>
                  </tr>

                  <tr v-if="Searh[0].guia!=''">
                    <th>Guia</th>
                    <td>{{Searh[0].guia}}</td>
                  </tr>               
                                    
                </table>
              </v-list-tile-content>
            </v-list-tile>

          </template>
           
        </v-list>
        <div class="pl-2 pr-2" v-if="Searh[0].fecha_entrada == '' && Searh[0].fecha_registro == ''">   
             <p class="subtitle-1 pl-2 pr-2 pt-4 pb-2">
                {{Searh[0].mensaje}}  
              <p>
              <div class="pl-2 pr-2">
                <v-btn color="info" to="/prealert-form" large block >Crear prealerta</v-btn> 
              </div> 
           </div>
           <div v-else> 
              <div v-if="Searh[0].id_paquete == '' || Searh[0].id_paquete == null" class="pl-2 pr-2">
                <v-btn color="info" to="/prealert-form" large block >Crear prealerta</v-btn> 
              </div>
              <div v-else class="pl-2 pr-2">
                <v-btn color="primary" @click="pickFile(Searh[0].guia,Searh[0].id_paquete)" large block >Cargar factura</v-btn> 
              </div>
           </div>
          
        </div>
          
        </v-flex>
  </v-layout>
</template>

<script>
  import Helpers from '../utils/helpers'
  import Server from '../utils/server'
export default {

  data () {
    return {
      clipped: false,
      currentUser: undefined,
      noData:false,
      loading: false,
      text4:'',
      Searh:[],
      currentUser: undefined,
      valid:false,required: [
        v => !!v || 'El campo es requerido'
      ]
    }
  },
  computed: {
    user(){
      return this.$store.getters.user;
    },
    login(){
      return this.$store.getters.login;
    },
    profile: function(){
      return this.$store.getters.profile
    }
  },
   mounted () {
    if(this.currentUser != undefined){  
    }else if(this.user.userName != null ){ 
      this.currentUser = this.user;
    }
    
  },
  methods: {
    pickFile (guia,idpack) {
      window.MobileApi.uploadInvoice(Server.uploadInvoice, guia, idpack, this.currentUser.userName,() =>{
        this.validateLogin();  
      });
    },
    validateLogin: function () {
        
        var formData = new FormData()
         formData.append('text1', this.currentUser.userName) 
         formData.append('text3', this.currentUser.pushId)
         formData.append('device', window.MobileApi.device)
         formData.append('text6', this.text4) 

        Helpers.getJson(Server.buscar, 'POST', formData, (json) => {
          console.log(json);
          if (json.length > 0){
            this.Searh=json; 
          }else{
            this.Searh=[];
          }
          
        })
        // this.$router.push('prealert')
      }
  },
  name: 'App'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
